import { apiClient } from '../../../api/client'
import { downloadXlsx } from '../../../lib/download'
import type { CriteriaScoreRange, CriteriaScoreRangeUpdate, PagedResponse } from '../types'

const BASE = '/management/criteria-score-ranges'

/** Silinmemiş kayıtların (sıralı) listesi. Sabit 3 bant → tek sayfada çekeriz (size=200). */
export async function getCriteriaScoreRanges(): Promise<PagedResponse<CriteriaScoreRange>> {
  const { data } = await apiClient.get<PagedResponse<CriteriaScoreRange>>(BASE, {
    params: { page: 0, size: 200 },
  })
  return data
}

/** Skor bandını güncelle (ad/skor/açıklama; optimistic lock modDate zorunlu). 200 → güncel kayıt. */
export async function updateCriteriaScoreRange(
  id: number,
  body: CriteriaScoreRangeUpdate,
): Promise<CriteriaScoreRange> {
  const { data } = await apiClient.put<CriteriaScoreRange>(`${BASE}/${id}`, body)
  return data
}

/**
 * Değerlendirme skoru bantlarını Excel (.xlsx) olarak indirir.
 *
 * Liste ucuyla aynı filtreler; sunucu **tüm** filtreli kayıtları döndürür (sayfalama yok). İndirme
 * mekaniği ve dosya adı ortak {@link downloadXlsx} yardımcısındadır (boş filtreler gönderilmez; ad
 * sunucunun Content-Disposition'ından okunur).
 */
export async function exportCriteriaScoreRanges(): Promise<void> {
  await downloadXlsx(`${BASE}/export`, {}, 'degerlendirme-skoru-bantlari.xlsx')
}
